<!--
 * @Author: zhanghan
 * @Date: 2022-11-24 00:16:12
 * @LastEditors: zhanghan
 * @LastEditTime: 2023-01-13 13:13:16
 * @Descripttion: APP主入口文件
-->
<template>
  <div>
    <vue-file-viewer />
  </div>
</template>

<script>
import { VueFileViewer } from '../packages'
export default {
  components: {
    VueFileViewer
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
